import SessionTypes from './SessionTypes';
import StorageHelper from '../../utils/StorageHelper';
import { STORAGE_KEYS } from '../../configs/AppConfig';

const _isAuthenticated = !!StorageHelper.getCookie(STORAGE_KEYS.session);
const initialState = {
  isAuthenticated: _isAuthenticated,
  isSessionValidating: _isAuthenticated // for rendering flash screen
};

export default function sessionReducer (state = initialState, action) {
  let newState;
  const { type, payload } = action;
  switch (type) {
    case SessionTypes.RESTORE_SESSION_SUCCESS:
      return Object.assign({}, state, {
        isAuthenticated: true,
        isSessionValidating: false,
        user: payload
      });

    case SessionTypes.LOG_IN_SUCCESS:
      return Object.assign({}, state, {
        isAuthenticated: true,
        isSessionValidating: false,
        user: payload.user
      });

    case SessionTypes.RESTORE_SESSION_FAILURE:
    case SessionTypes.REAUTHORIZE:
    case SessionTypes.LOG_IN_ERROR:
    case SessionTypes.LOG_OUT:
      return Object.assign({}, state,
        {
          isAuthenticated: false,
          isSessionValidating: false,
          authToken: '',
          user: {}
        }
      );

    default:
      newState = state;
  }

  return newState;
}
